import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { generateSource } from 'cio/utils/analytics/sources';

const Transforms: TransformsList = {
  base(data: Data) {
    return {
      Source: generateSource(data),
    };
  },

  clicked(data: Data) {
    return {
      'Shortcut Type': data.shortcut.webhook ? 'Webhook' : 'URL',
      'Shortcut URL': data.shortcut.webhook ? null : data.shortcut.url,
      'Webhook Hostname': data.shortcut.webhook ? data.shortcut.url : null,
      Source: generateSource(data),
    };
  },
};

export default Transforms;
